module.exports = __webpack_public_path__ + "images/assets/9bb3b2e4421c327175ee408a81aac293.svg";